module.exports = __webpack_public_path__ + "static/media/trailer.a08aea84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trailer.svg
// module id = 1297
// module chunks = 0